export default __webpack_public_path__ + "static/observatory-c1acf174713bb220b9510897f4b4d1e3.png";